import React from 'react';
import './App.css';
import { Switch, Route } from 'react-router-dom';
import NavBarCognito from './components/NavBarCognito';
import Footer from './components/Footer';
import { PassportVerificationCognitoContainer } from './containers/PassportVerificationCognitoContainer';
import CognitoAuth from './containers/CognitoAuth';
import { currentBrand } from './utils/brand';
import { initializeGoogleAnalytics } from './utils/analytics';

function App() {
  const brandName = process.env.REACT_APP_BRAND;
  const headEl = document.getElementsByTagName('head')[0];

  // set favicon
  const linkFaviconEl = document.createElement('link');
  linkFaviconEl.rel = 'icon';
  linkFaviconEl.href = `${process.env.PUBLIC_URL}/${brandName}/favicon.ico`;
  headEl.appendChild(linkFaviconEl);

  // set Apple icon
  const linkAppleIconEl = document.createElement('link');
  linkAppleIconEl.rel = 'apple-touch-icon';
  linkAppleIconEl.href = `${process.env.PUBLIC_URL}/${brandName}/logo192.png`;
  headEl.appendChild(linkAppleIconEl);

  // set title
  const titleEl = document.createElement('title');
  titleEl.innerText = `Register account for ${currentBrand().displayName}`;
  headEl.appendChild(titleEl);

  // set manifest.json
  const linkManifestEl = document.createElement('link');
  linkManifestEl.rel = 'manifest';
  linkManifestEl.href = `${process.env.PUBLIC_URL}/${brandName}/manifest.json`;
  headEl.appendChild(linkManifestEl);

  initializeGoogleAnalytics();

  return (
    <CognitoAuth>
      <div className={`App ${brandName}`}>
        <NavBarCognito />
        <Switch>
          <Route path="/" component={PassportVerificationCognitoContainer} />
        </Switch>
        <Footer />
      </div>
    </CognitoAuth>
  );
}

export default App;
